const data = {
  pageName: "RedPass",
  siteKey: "6LdJfokUAAAAAGY_EgOdZcnrn1PaINlO2KBJn7i2",
  secretCaptcha: "Secret Code",
  services: {
    checkRedPassEligibility: {
      url: "redPass/checkRedPassEligibility",
      params: {}
    },
    translations: {
      url: "redPass/redPassTranslations",
      params: {}
    },
    redPassContent: {
      url: "redPass/redPassContent",
      params: {}
    }
  }
};
exports.data = data;
